import { validCPF } from "core/functions/validations";
import * as Yup from "yup";

export const creditCardSchema = Yup.object().shape({
  holderName: Yup.string()
    .required("Nome do titular é obrigatório")
    .matches(/^[A-Za-zÀ-ÖØ-öø-ÿ\s]+$/, "O nome deve conter apenas letras e espaços"),
  
  number: Yup.string()
    .transform((value) => value.replace(/\s+/g, "")) // Remove espaços extras
    .matches(/^[0-9]{16}$/, "Número do cartão deve ter 16 dígitos")
    .required("Número do cartão é obrigatório"),
  
  expiration: Yup.string()
    .matches(/^(0[1-9]|1[0-2])\/\d{4}$/, "Formato inválido. Use MM/AAAA.")
    .test("valid-date", "A validade do cartão está expirada.", (value) => {
      if (!value) return false;
      const [month, year] = value.split("/").map(Number);
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth() + 1;

      // Verifica se o ano é válido e se a data ainda não expirou
      return year > currentYear || (year === currentYear && month >= currentMonth);
    })
    .required("Campo obrigatório"),  
  
  cvv: Yup.string()
    .matches(/^[0-9]{3,4}$/, "CVV deve ter 3 ou 4 dígitos")
    .required("CVV é obrigatório"),
  
  brand: Yup.string()
    .required("Bandeira do cartão obrigatória"),

  holderDocument: Yup.string()
    .required(" ")
    .test("min-digits", " ", (value) => {
      if (value && value.replace(/[^\d]+/g, "").length < 11) {
        return false;
      }
      return true;
    })
    .test("valid-cpf", "CPF inválido", (value) => {
      if (value && value.replace(/[^\d]+/g, "").length === 11) {
        return validCPF(value);
      }
      return true;
    }),
  reuse: Yup.boolean(), // Esse campo pode ser opcional
  installmentsNumber: Yup.string()
    .required("A seleção de parcelamento é obrigatória")
});

export const pixAndTicketSchema = Yup.object().shape({
  identification: Yup.boolean().required("Campo obrigatório"), // Torna o campo obrigatório

  installmentsNumber: Yup.string()
    .required("A seleção de parcelamento é obrigatória"),
});

